import { render } from "./ImpressumDE.vue?vue&type=template&id=14114870&lang=de"
import script from "./ImpressumDE.vue?vue&type=script&lang=js"
export * from "./ImpressumDE.vue?vue&type=script&lang=js"

import exportComponent from "M:\\Me\\WebPortfolio_2022\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__